module.exports = __webpack_public_path__ + "static/img/block2_1.1f3ca43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/parkDescription/block2_1.png
// module id = V1S+
// module chunks = 1